export default "__VITE_ASSET__B3k$sGdK__"